var _rect, _rect2, _path, _path2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#F4F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 10,
    height: 16,
    rx: 4,
    stroke: "#BCD5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H12V4H13C15.2091 4 17 5.79086 17 8V11Z",
    stroke: "#BCD5F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C7 5.79086 8.79086 4 11 4H12V11H7V8Z",
    stroke: "#BCD5F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 8,
    width: 3,
    height: 4,
    fill: "#F4F9FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9,
    width: 1,
    height: 3,
    rx: 0.5,
    fill: "#2264C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIcon);
export default __webpack_public_path__ + "static/media/MouseIcon.62a3319caad41f9d90f33cd0965b58c1.svg";
export { ForwardRef as ReactComponent };